import { Action } from '@ngrx/store';
import { Update } from '@ngrx/entity';
import { SoftwareData } from '../software.model';

export enum SoftwareActionTypes {
  GetSoftwareVersionData = '[Software] Get Software Version Data',
  UpsertSoftwareVersionData = '[Software] Upsert Software Version Data',
  GetSoftwareVersionDataFail = '[Software] Get Software Version Data Fail'
}

export class GetSoftwareVersionData implements Action {
  readonly type = SoftwareActionTypes.GetSoftwareVersionData;

  constructor(public payload: any = null) {}
}

export class UpsertSoftwareVersionData implements Action {
  readonly type = SoftwareActionTypes.UpsertSoftwareVersionData;

  constructor(public payload: any = null) {}
}

export class GetSoftwareVersionDataFail implements Action {
  readonly type = SoftwareActionTypes.GetSoftwareVersionDataFail;
  
  constructor(public payload: any = null) {}
}

export type SoftwareActions =
 GetSoftwareVersionData
 | UpsertSoftwareVersionData
 | GetSoftwareVersionDataFail;
